import { getChatHistory, setChatHistory, getLocalStorageSize } from "@/utils/localStorageData";
import { CancelTokenSource } from "axios";
import { useEffect, useRef } from "react";

export default function chatPageHook<T>(option: {
  setChatList: React.Dispatch<React.SetStateAction<T[]>>;
  storageKey?: string;
  source?: CancelTokenSource;
  abort?: () => void; // 取消流式请求
}) {

  const chatBox = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    setTimeout(() => {
      chatBox.current && (chatBox.current.scrollTop = chatBox.current?.scrollHeight);
    }, 10);
  };

  useEffect(() => {
    if (option.storageKey) {
      const lastChat = getChatHistory(option.storageKey);
      lastChat && option.setChatList(lastChat);
      scrollToBottom();
    }
    return () => {
      option.source?.cancel("abort");
      option.abort?.();
      // console.log('localStorage size :>> ', getLocalStorageSize());
    }
  }, []);

  return { 
    chatBox, 
    scrollToBottom,
    setChatHistory,
  };

}
